import React, { useEffect, useContext } from "react";
import { MisDocumentosContext } from "../../../../../../../context/v3/MisDocumentosContext";
import { Button, Card, Table } from "antd";
import { FormOutlined, SearchOutlined } from "@ant-design/icons";
import { ColumnaDocumento } from "./componentes/ColumnaDocumento";
import { ColumnaEstadoDocumento } from "./componentes/ColumnaEstadoDocumento";
import { SecurityContext } from "../../../../../../../context/SecurityContextProvider";
import { CategoriaDocumento } from "enum/CategoriaDocumento";
import { EstadoVistaColaborador } from "enum/EstadoVistaColaborador";
import { useAtom } from "jotai";
import {
	formularioSeleccionadoAtom,
	visibleVisorFormularioAtom,
	visibleModalConsentimientoDatosAtom,
	documentoConsentimientoAtom,
	loadingPdfAtom,
} from "../../MisDocumentosWebStorage";
import { visibleModalAlertaAtom } from "pages/v3/mis-pendientes/storage/MisDocumentosStorage";
import { useModalRegistrarAsistencia } from "pages/v3/mis-pendientes/common/hooks";
import { agruparPorOnboarding, aplicaAgrupacionOnboarding } from "pages/v3/mis-pendientes/common/utils/agruparPorOnboarding";

const NOMBRE_DOCUMENTO_CONSENTIMIENTO = "CONSENTIMIENTO PARA USO DE DATOS PERSONALES-IMAGEN";
export function ListaDocumentos() {
	const [, setFormularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);
	const [, setVisibleModalAlerta] = useAtom(visibleModalAlertaAtom);
	const [, setLoadingPdf] = useAtom(loadingPdfAtom);
	const [, setVisibleModalConsentimiento] = useAtom(visibleModalConsentimientoDatosAtom);
	const [, setDocumentoConsentimiento] = useAtom(documentoConsentimientoAtom);

	const {
		loading,
		documentos,
		getDocumentos,
		mostrarVisorPdf,
		setDocumentoSeleccionado,
		mostrarModalUpload
	} = useContext(MisDocumentosContext);

	const { getUsuarioAutenticado } = useContext(SecurityContext);

	const { abrirModal: abrirModalRegistrarAsistencia } = useModalRegistrarAsistencia();

	useEffect(() => {
		getDocumentos(getUsuarioAutenticado().empresaSeleccionada.id, getUsuarioAutenticado().numeroDocumentoIdentidad);
	}, []);

	useEffect(() => {
		const esExplomin = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837";
		if (esExplomin && !loading && documentos && documentos.length > 0) {
			const docConsentimiento = documentos.find(
				(doc) =>
					doc.nombreDocumento &&
					doc.nombreDocumento.toUpperCase().includes(NOMBRE_DOCUMENTO_CONSENTIMIENTO) &&
					doc.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE
			);
			if (docConsentimiento) {
				setDocumentoConsentimiento(docConsentimiento);
				setVisibleModalConsentimiento(true);
			}
		}
	}, [documentos, loading]);

	async function onClickVerDocumento(documento) {
		if (documento.permitirVisualizarDocumento) {
			mostrarVisorPdf(documento.id);
		} else {
			setVisibleModalAlerta(true);
		}
	}

	async function onClickCargar(documento) {
		if (documento.permitirVisualizarDocumento) {
			setDocumentoSeleccionado(documento);
			mostrarModalUpload(documento.id);
		} else {
			setVisibleModalAlerta(true);
		}
	}

	const onClickCompletarFormulario = (formulario) => {
		if (formulario.permitirVisualizarDocumento) {
			setDocumentoSeleccionado(formulario); //uso temporal mientras se use ContextProvider
			setFormularioSeleccionado(formulario);
			setVisibleVisorFormulario(true);
			setLoadingPdf(true);
		} else {
			setVisibleModalAlerta(true);
		}
	};

	const onClickCompletarTareaPendiente = (formulario) => {
		if (formulario.permitirVisualizarDocumento) {
			setDocumentoSeleccionado(formulario); //uso temporal mientras se use ContextProvider
			setFormularioSeleccionado(formulario);
			setVisibleVisorFormulario(true);
			setLoadingPdf(true);
		} else {
			setVisibleModalAlerta(true);
		}
	};

	const columnas = [
		{
			title: "Documento",
			key: "descripcion",
			render: (text, fila) => <ColumnaDocumento fila={fila} />,
		},
		{
			title: "Estado",
			align: "center",
			dataIndex: "estado",
			key: "estado",
			render: (text, fila) => (
				<ColumnaEstadoDocumento
					permitirVisualizarDocumento={fila.permitirVisualizarDocumento}
					estado={fila.estadoVistaColaborador}
					estadoAprobacion={fila.estadoAprobacion}
				/>
			),
		},
		{
			title: "Fecha de envío",
			align: "center",
			dataIndex: "fechaEnvio",
			key: "fechaEnvio",
		},
		{
			title: "Acciones",
			key: "acciones",
			align: "center",
			render: (texto, fila) => {
				if (
					(fila.categoriaDocumentoId === CategoriaDocumento.FORMULARIO || fila.categoriaDocumentoId === CategoriaDocumento.FORMATO_AUSENCIA) &&
					(fila.estadoVistaColaborador !== EstadoVistaColaborador.FIRMADO ||
						(fila.estadoAprobacion != null && fila.estadoAprobacion === "RECHAZADO"))
				) {
					return (
						<Button type="link" onClick={() => onClickCompletarFormulario(fila)}>
							<FormOutlined /> Ver Documento
						</Button>
					);

				} else if (fila.categoriaDocumentoId === CategoriaDocumento.FLUJO_FIRMA) {
					return (
						<Button type="link" onClick={() => onClickCompletarFormulario(fila)}>
							<FormOutlined /> Firmar Documento
						</Button>
					);
				} else if (fila.categoriaDocumentoId === CategoriaDocumento.TAREA_PENDIENTE) {
					return (
						<Button type="link" onClick={() => onClickCompletarTareaPendiente(fila)}>
							<FormOutlined /> Firmar Documento
						</Button>
					);
				} else if (
					fila.categoriaDocumentoId === CategoriaDocumento.CARGA_DOCUMENTO &&
					(fila.estadoVistaColaborador !== EstadoVistaColaborador.FIRMADO ||
						(fila.estadoAprobacion != null && fila.estadoAprobacion === "RECHAZADO"))
				) {
					return (
						<Button type="link" onClick={() => onClickCargar(fila)}>
							<FormOutlined /> Cargar
						</Button>
					);
				} else if (fila.categoriaDocumentoId === CategoriaDocumento.REGISTRO_ASISTENCIA) {
					return (
						<Button type="link" onClick={() => abrirModalRegistrarAsistencia(fila)}>
							<FormOutlined /> Firmar Asistencia
						</Button>
					);
				}

				return (
					<Button type="link" onClick={() => onClickVerDocumento(fila)}>
						<SearchOutlined /> Ver Documento
					</Button>
				);
			},
		},
	];

	const columnaNumero = {
		title: "N°",
		key: "numero",
		width: 60,
		align: "center",
		render: (text, fila, index) => index + 1,
	};

	const agrupar = aplicaAgrupacionOnboarding(getUsuarioAutenticado()) && (documentos || []).some((d) => d.onboardingNombre);

	if (agrupar && !loading) {
		return (
			<>
				{agruparPorOnboarding(documentos).map((grupo) => (
					<Card
						key={grupo.id}
						size="small"
						style={{ marginBottom: 16 }}
						title={`${grupo.nombre} (${grupo.documentos.length})`}
					>
						<Table
							rowKey={(documento) => documento.id}
							dataSource={grupo.documentos}
							columns={[columnaNumero, ...columnas]}
							pagination={false}
						/>
					</Card>
				))}
			</>
		);
	}

	return (
		<Table
			rowKey={(documentos) => documentos.id}
			dataSource={documentos}
			columns={columnas}
			loading={loading}
			pagination={false}
		/>
	);
}
